<div class="overlay" *ngIf="showSpinner">
  <div class="spinner-wrapper">
    <app-spinner><span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span></app-spinner>
  </div>
</div>
<package-receive-progress></package-receive-progress>

<div class="steps-content">
  <p-card>
    <ng-template pTemplate="title">
      Tracking Number
    </ng-template>
    <ng-template pTemplate="subtitle">
      Scan or enter an existing tracking number or generate one if there is no existing tracking number
    </ng-template>
    <ng-template pTemplate="content">
      <input #searchTracking name="searchTracking" type="text" [(ngModel)]="package.trackingNumber">
      <button (click)="handleSearchButton()" style="margin-left:10px; padding:4px" title="Look up tracking number"><i class="fa fa-search fa-3x"></i></button>
      <button (click)="generateTrackingNumber()" style="margin-left:10px; padding:4px" title="Generate tracking number"><i class="fa fa-magic fa-3x"></i></button>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="grid p-nogutter p-justify-end">
        <!--<p-button label="Back" (onClick)="prevPage()" icon="pi pi-angle-left"></p-button>-->
        <!--<button class="pull-right navbutton" (onClick)="nextPage()" icon="pi pi-angle-right" iconPos="right">Next</button>-->
      </div>
    </ng-template>
  </p-card>
</div>
<p-toast>
</p-toast>
<p-confirmDialog header="Duplicate Tracking Number" icon="pi pi-exclamation-triangle"></p-confirmDialog>
